export const broadcast = {
  namespaced: true,
  state: {
    broadcastActionList: []
  },
  getters: {
    broadcastActionList: state => state.broadcastActionList
  },
  mutations: {
    SET_BROADCAST_ACTION_LIST(state, broadcastActionList) {
      state.broadcastActionList = broadcastActionList;
    },

    SPLICE_BROADCAST_ACTION_LIST(state, broadcastEvent) {
      let broadcastActionList = state.broadcastActionList;

      let idx = broadcastActionList.findIndex(
        broadcast =>
          broadcast.action == broadcastEvent.action &&
          broadcast.signal == broadcastEvent.signal
      );
      if (idx >= 0) {
        broadcastActionList.splice(idx, 1);
      }
    }
  },
  actions: {
    createBroadcastAction({ commit, getters }, broadcastAction) {
      // Always clone the array instead of mutating in place
      const newList = [...getters.broadcastActionList, broadcastAction];
      commit("SET_BROADCAST_ACTION_LIST", newList);
    },

    removeBroadcastAction({ commit }, broadcastAction) {
      commit("SPLICE_BROADCAST_ACTION_LIST", broadcastAction);
    }
  }
};
